import { company } from "../../../utilities/CustomerData";

export function DashboardDocsReceivedAtIRS() {
  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-4'>
            <p className='font-bold text-xl text-center'>No Additional Step Required at this Time.</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <div className='w-full flex flex-col items-start gap-4'>
          <p className='font-bold text-xl text-[#646464]'>The IRS Has Received Your Packet!</p>
          <p className='text-xl text-[#646464]'>Great news! The IRS has successfully received your documents, and your Express Refund will now be processed and sent directly to your account.</p>
          <p className='font-bold text-xl text-[#646464]'>What Happens Next:</p>
          <p className='text-xl text-[#646464]'>Express Refund Processed - Once your packet is processed, your Express Refund will be issued directly to the account you previously verified.</p>
          <p className='text-xl text-[#646464]'>Thank you for choosing {company.companyName}!</p>
        </div>
      </div>
    </div>
  )
}